import { render, staticRenderFns } from "./witness_warn_notice.vue?vue&type=template&id=3bb777c0&scoped=true"
import script from "./witness_warn_notice.vue?vue&type=script&lang=js"
export * from "./witness_warn_notice.vue?vue&type=script&lang=js"
import style0 from "./witness_warn_notice.vue?vue&type=style&index=0&id=3bb777c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb777c0",
  null
  
)

export default component.exports